import { User } from '../types';
import axiosConnector from './axiosConnector';
import { API_URL } from './axiosConnector';
import { fromUserDTO } from '../dto/userDTO';

interface UpdateUserData {
  id: number;
  firstname?: string;
  lastname?: string;
  currentPassword?: string;
  newPassword?: string;
  avatarSrc?: string;
  email?: string;
  phoneNumber?: string;
  username?: string;
  role: string;
}

interface AuthUser {
  id: number;
  name: string;
  username: string;
  firstname: string;
  lastname: string;
  avatarSrc: string;
  email: string;
  phone_number: string;
  role: string;
}

export const updateUser = async (
  userData: UpdateUserData
): Promise<AuthUser | null> => {
  try {
    const userResponse = await axiosConnector.patch<User>(
      `${API_URL}/users/${userData.id}`,
      fromUserDTO(userData)
    );

    // Convert the response to match AuthContext's User interface
    return {
      id: userData.id,
      name: `${userData.firstname} ${userData.lastname}`,
      username: userData.username || '',
      firstname: userData.firstname || '',
      lastname: userData.lastname || '',
      avatarSrc: userData.avatarSrc || '',
      email: userData.email || '',
      phone_number: userData.phoneNumber || '',
      role: userData.role || ''
    };
  } catch (error) {
    console.error(error);
    return null;
  }
};

